var $4a197b587740ff5d$exports = {};
$4a197b587740ff5d$exports = {
    "loading": `Y\xfckleniyor...`,
    "placeholder": `Se\xe7in\u{2026}`
};


export {$4a197b587740ff5d$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
